(function($) {
    $(function() {
        var lazyImages = [].slice.call(document.querySelectorAll('img.lazy'));
      	var lazyLabels = [].slice.call(document.querySelectorAll('label.lazy'));
      	var zoomImg = [].slice.call(document.querySelectorAll('img.zoomImg'));
        if ('IntersectionObserver' in window) {
            window.lazyImageObserver = new IntersectionObserver(function(entries, observer) {
                entries.forEach(function(entry) {
                    if (!entry.isIntersecting) return;
                  //console.log("Observing: ", entry);
                    var lazyImage = entry.target;
                    lazyImage.src = lazyImage.dataset.src || lazyImage.dataset.source;
                    if (lazyImage.dataset.srcset) lazyImage.srcset = lazyImage.dataset.srcset;
                    lazyImage.classList.remove('lazy');
                    window.lazyImageObserver.unobserve(lazyImage);
                });
            });

            lazyImages.forEach(function(lazyImage) {
                window.lazyImageObserver.observe(lazyImage);
            });
          	
          window.lazyLabelObserver = new IntersectionObserver(function(entries, observer){
            entries.forEach(function(entry){
             	if (!entry.isIntersecting) return;
              	var lazyLabel = entry.target;
              	lazyLabel.style.backgroundImage = lazyLabel.dataset.src || lazyLabel.dataset.source;
              	lazyLabel.classList.remove('lazy');
              	window.lazyLabelObserver.unobserve(lazyLabel);
            });
          });
          
          lazyLabels.forEach(function(lazyLabel){
           	window.lazyLabelObserver.observe(lazyLabel); 
          });
          
        } else {
            console.error('IntersectionObserver not found!');
        }
    });
})(jQuery);

